// extracted by mini-css-extract-plugin
export default {"steps":"InviteNewUserDIalog_steps__z7H5J"};